import React from "react";

import { Typography } from "@mui/material";
import { capitalize } from "lodash";
import { makeStyles } from "tss-react/mui";

import PersonCheckIcon from "@/components/Icons/PersonCheckIcon";
import PersonCrossIcon from "@/components/Icons/PersonCrossIcon";
import { ClientStatus, Client } from "@/gql/graphql";

interface Props {
  status?: Client["status"];
}

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    fontSize: 18,
  },
  label: {
    marginLeft: 6,
    color: "#c0c5cd",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: 1,
  },
  labelInactive: {
    color: "#c0c5cd",
  },
  labelActive: {
    color: theme.palette.primary.main,
  },
}));

const BillingStatus: React.FC<Props> = ({ status }) => {
  const { classes, cx } = useStyles();

  return (
    <div className={classes.root}>
      {status === ClientStatus.Active && <PersonCheckIcon fontSize="inherit" />}
      <Typography
        className={cx(classes.label, {
          [classes.labelActive]: status === ClientStatus.Active,
          [classes.labelInactive]: status === ClientStatus.Inactive,
        })}
      >
        {status === ClientStatus.Active ? capitalize(status ?? undefined) : ""}
      </Typography>
    </div>
  );
};

export default BillingStatus;
